import {Box, Grid, TextField, Typography, styled} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../../components/MWCaption";

import CategoryIcon from "@mui/icons-material/Category";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "400px",
  backgroundColor: "#fff",
  "& p": {
    marginTop: "8px",
    textAlign: "center",
  },
}));

const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "240px",
  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

type SubTitleColorProps = {
  captionColor?: string;
};

const CategoryForm = ({captionColor}: SubTitleColorProps) => {
  const {control} = useFormContext();

  return (
    <React.Fragment>
      <MWCaption title="카테고리 관리" color={captionColor} icon={<CategoryIcon />} />
      <CategoryFormContainer container>
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <Controller
            name="name"
            control={control}
            defaultValue={""}
            render={({field, fieldState: {error}}) => (
              <Box>
                <CategoryFormContent>
                  <label htmlFor="name">카테고리 : </label>
                  <TextField
                    {...field}
                    id="name"
                    size="small"
                    placeholder="카테고리"
                    autoFocus
                    helperText={error?.message}
                  />
                </CategoryFormContent>
              </Box>
            )}
          />
        </Grid>
      </CategoryFormContainer>
    </React.Fragment>
  );
};

export default CategoryForm;
